var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1010 10A10.011 10.011 0 0010 0zm0 18.333A8.333 8.333 0 1118.333 10 8.342 8.342 0 0110 18.333zM14.167 10a.833.833 0 01-.834.833h-2.5v2.5a.834.834 0 01-1.666 0v-2.5h-2.5a.834.834 0 010-1.666h2.5v-2.5a.833.833 0 111.666 0v2.5h2.5a.833.833 0 01.834.833z"
  })));
}

export default SvgPlusinline;